module.exports = __webpack_public_path__ + "static/media/alunno.acf0d764.svg";